import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "./local-storage";
import { LOCAL_STORAGE_VARIABLES } from "./local-storage/constants/local-storage";

/**
 * Заявка, по которой сейчас идёт обмен. Держим в localStorage, а не в zustand:
 * стор не персистится и обнуляется при уходе с главной, а плашка «Активный
 * обмен» должна пережить и уход в банк, и перезапуск мини-аппа.
 *
 * Рядом с id лежат deepLink и qrUrl: они приходят только в ответе на создание
 * заявки, в GET /exchange/:id их нет, а экран оплаты без них пустой.
 */
export interface ActiveExchange {
  id: string;
  deepLink?: string;
  qrUrl?: string;
}

const ACTIVE_EXCHANGE_EVENT = "active-exchange-change";

export const getActiveExchange = (): ActiveExchange | null => {
  const raw = getLocalStorage(LOCAL_STORAGE_VARIABLES.ACTIVE_EXCHANGE);

  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as ActiveExchange;

    return parsed?.id ? parsed : null;
  } catch {
    return null;
  }
};

export const setActiveExchange = (exchange: ActiveExchange) => {
  setLocalStorage(
    LOCAL_STORAGE_VARIABLES.ACTIVE_EXCHANGE,
    JSON.stringify(exchange),
  );
  window.dispatchEvent(new Event(ACTIVE_EXCHANGE_EVENT));
};

export const clearActiveExchange = () => {
  removeLocalStorage(LOCAL_STORAGE_VARIABLES.ACTIVE_EXCHANGE);
  window.dispatchEvent(new Event(ACTIVE_EXCHANGE_EVENT));
};

export const subscribeActiveExchange = (listener: () => void) => {
  window.addEventListener(ACTIVE_EXCHANGE_EVENT, listener);
  window.addEventListener("storage", listener);

  return () => {
    window.removeEventListener(ACTIVE_EXCHANGE_EVENT, listener);
    window.removeEventListener("storage", listener);
  };
};
